module.exports = __webpack_public_path__ + "img/FAQ-B.eee668df.jpg";